module.exports = __webpack_public_path__ + "static/kesem-1-3eadc6026e6587f2f9b2377f8a9dfcd9.jpg";